var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_16269",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_16269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66665 13.8337C2.29998 13.8337 1.98609 13.7031 1.72498 13.442C1.46387 13.1809 1.33331 12.867 1.33331 12.5003V4.50033C1.33331 4.13366 1.46387 3.81977 1.72498 3.55866C1.98609 3.29755 2.29998 3.16699 2.66665 3.16699H13.3333C13.7 3.16699 14.0139 3.29755 14.275 3.55866C14.5361 3.81977 14.6666 4.13366 14.6666 4.50033V12.5003C14.6666 12.867 14.5361 13.1809 14.275 13.442C14.0139 13.7031 13.7 13.8337 13.3333 13.8337H2.66665ZM7.99998 9.16699L2.66665 5.83366V12.5003H13.3333V5.83366L7.99998 9.16699ZM7.99998 7.83366L13.3333 4.50033H2.66665L7.99998 7.83366ZM2.66665 5.83366V4.50033V12.5003V5.83366Z",
    fill: "#0d63ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailActivity);
export default __webpack_public_path__ + "static/media/email_activity.47c837a7dbcbca5434ad816aa0ee37bf.svg";
export { ForwardRef as ReactComponent };